var faqData = {};

faqData.en = {
  title: 'Frequently Asked Questions',
  subtitle: 'Find answers to common questions about our products, shipping, and more.',
  support: 'Support',
  stillQuestions: 'Still have questions?',
  stillQuestionsDesc: "We're here to help. Send us a message and we'll get back to you.",
  contactUs: 'Contact Us',
  importTaxDisclaimer: "Consult your country's laws and policies before buying. By purchasing, you agree to these terms and conditions."
};

faqData.es = {
  title: 'Preguntas Frecuentes',
  subtitle: 'Encuentra respuestas a preguntas comunes sobre nuestros productos, envios y mas.',
  support: 'Soporte',
  stillQuestions: 'Aun tienes preguntas?',
  stillQuestionsDesc: 'Estamos aqui para ayudarte. Envianos un mensaje y te responderemos.',
  contactUs: 'Contactanos',
  importTaxDisclaimer: 'Consulta las leyes y politicas de tu pais antes de comprar. Al comprar, aceptas estos terminos y condiciones.'
};

faqData.ja = {
  title: 'よくある質問',
  subtitle: '製品、配送などに関するよくある質問への回答をご覧ください。',
  support: 'サポート',
  stillQuestions: 'まだ質問がありますか？',
  stillQuestionsDesc: 'お気軽にメッセージをお送りください。',
  contactUs: 'お問い合わせ',
  importTaxDisclaimer: '購入前にお住まいの国の法律とポリシーをご確認ください。購入することでこれらの条件に同意したものとみなされます。'
};

faqData.de = {
  title: 'Haufig gestellte Fragen',
  subtitle: 'Antworten auf haufige Fragen zu unseren Produkten, Versand und mehr.',
  support: 'Support',
  stillQuestions: 'Noch Fragen?',
  stillQuestionsDesc: 'Wir helfen Ihnen gerne. Senden Sie uns eine Nachricht.',
  contactUs: 'Kontakt',
  importTaxDisclaimer: 'Bitte informieren Sie sich vor dem Kauf uber die Gesetze und Richtlinien Ihres Landes. Mit dem Kauf stimmen Sie diesen Bedingungen zu.'
};

faqData.fr = {
  title: 'Questions Frequentes',
  subtitle: 'Trouvez des reponses aux questions courantes sur nos produits, livraison et plus.',
  support: 'Support',
  stillQuestions: 'Encore des questions ?',
  stillQuestionsDesc: 'Nous sommes la pour vous aider. Envoyez-nous un message.',
  contactUs: 'Contactez-nous',
  importTaxDisclaimer: "Consultez les lois et politiques de votre pays avant d'acheter. En achetant, vous acceptez ces termes et conditions."
};

faqData.it = {
  title: 'Domande Frequenti',
  subtitle: 'Trova risposte alle domande comuni sui nostri prodotti, spedizioni e altro.',
  support: 'Supporto',
  stillQuestions: 'Hai ancora domande?',
  stillQuestionsDesc: 'Siamo qui per aiutarti. Inviaci un messaggio.',
  contactUs: 'Contattaci',
  importTaxDisclaimer: 'Consulta le leggi e le politiche del tuo paese prima di acquistare. Acquistando, accetti questi termini e condizioni.'
};

export default faqData;
